import { render, staticRenderFns } from "./FSelectGapColorField.vue?vue&type=template&id=4db9987f&"
import script from "./FSelectGapColorField.vue?vue&type=script&lang=ts&"
export * from "./FSelectGapColorField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports